interface Error {
  message: string
  path: string
}

interface ILoginResponse {
  errors?: Error[]
  accessToken?: string
  refreshToken?: string
}

export const login = (
  apiUrl: string | undefined | null,
  values: {
    email: string
    password: string
  }
): Promise<ILoginResponse> =>
  fetch(`${apiUrl ?? ''}/auth/token`, {
    body: JSON.stringify({ ...values, grantType: 'password' }),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      return {
        accessToken: data['access_token'],
        errors: data['errors'],
        refreshToken: data['refresh_token'],
      }
    })
